import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FiDownload } from "react-icons/fi";
import HtmlParser from "react-html-parser";


export default function SimpleSlider(Banner) {
  var settings = {
    dots: true,
    infinite: true,
    arrow: true,
    fade: false,
    speed: 1000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  return (
    <div className="h-ban">
    <Slider {...settings}>
      {Banner?.Banner?.map((dataBanner) => (
        <div key={dataBanner?.id}>
          <img
            className="homeBanner position-relative"
            src={
              process.env.REACT_APP_IMAGE_BASE_URL +
              dataBanner?.Image?.data?.attributes?.url
            }
            width="100%"
            height="100%"
            alt=""
          />

          <div className="position-absolute intro">
            <p className="banner-num">
              01
              <span className="banner-title">{dataBanner.Subtitle}</span>
            </p>
            <p className="txt1 pt-3">{HtmlParser(dataBanner.Title)}</p>
            <p className="txt7">{HtmlParser(dataBanner.Description)} </p>
            <a target="_blank"
              href={
                process.env.REACT_APP_IMAGE_BASE_URL +
                dataBanner?.File?.data?.attributes?.url
              }
              download
              className="btn brochure btn-color btn-l-r mt-5"
            >
              <FiDownload />
              &nbsp; &nbsp;Download Brochure
            </a>
          </div>
        </div>
      ))}
    </Slider>
    </div>
  );
}
